module.exports = __webpack_public_path__ + "static/media/app-01.58d7b2d0.png";